<template>
  <div>
    <LDBsTable
      url="infractions-types"
      defaultSort="codigo_infracao_tipo"
      defaultOrder="asc"
      :query="query"
      :columns="columns"
      :clear="clear"
      :defaultOptions="options"
    >
      <div class="form-group col-lg-6">
        <label for="infraction_type_code">{{ $t("infraction_type_code") }}</label>
        <input
          type="text"
          id="infraction_type_code"
          name="infraction_type_code"
          class="form-control"
          :placeholder="$t('ph_infraction_type_code')"
          v-model="query.codigo_infracao_tipo"
        />
      </div>

      <div class="form-group col-lg-6">
        <label for="infraction_type_description">{{ $t("infraction_type_description") }}</label>
        <input
          type="text"
          id="infraction_type_description"
          name="infraction_type_description"
          class="form-control"
          :placeholder="$t('ph_infraction_type_description')"
          v-model="query.descricao_infracao_tipo"
        />
      </div>

      <div class="form-group col-lg-6">
        <label for="nivel_infracao_tipo">{{ $t("infraction_level") }}</label>
        <vue-select
          class="bg-white"
          name="nivel_infracao_tipo"
          :placeholder="$t('select_a_item')"
          :options="infractionsLevels"
          v-model="query.nivel_infracao_tipo"
          :select-on-tab="true"
        />
      </div>

      <div class="form-group col-lg-6">
        <label for="isActive">{{ $t("active") }}</label>
        <vue-select
          class="bg-white"
          name="isActive"
          :placeholder="$t('select_a_item')"
          label="label"
          :options="[
            { label: 'SIM', value: true },
            { label: 'NÃO', value: false },
          ]"
          v-model="query.ativo_infracao_tipo"
          :reduce="(query) => query.value"
          :select-on-tab="true"
        />
      </div>
    </LDBsTable>
  </div>
</template>

<script>
import LDBsTable from "@/components/shared/LDBsTable";
import infractionsLevels from "@/config/infractionLevels"

export default {
  name: "InfractionTypeList",
  components: {
    LDBsTable,
  },
  data() {
    return {
      columns: [
        {
          title: "Código Tipo Infração",
          field: "codigo_infracao_tipo",
          sortable: true,
        },
        {
          title: "Descrição",
          field: "descricao_infracao_tipo",
          sortable: true,
        },
        {
          title: "Nível Infração",
          field: "nivel_infracao_tipo",
          sortable: true,
        },
        {
          title: this.$t("active"),
          field: "ativo_infracao_tipo",
          formatter: function (value) {
            return value ? "SIM" : "NÃO";
          },
          sortable: true,
        },
        {
          key: "id",
          field: "id",
          align: "center",
          width: "100%",
          formatter: function (value) {
            return `<a href="#/main/frota/infraction-type/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`;
          },
        },
      ],
      options: {
        exportOptions: { fileName: "tipos_de_infracao" },
      },
      query: {
        codigo_infracao_tipo: "",
        descricao_infracao_tipo: "",
        ativo_infracao_tipo: null,
        nivel_infracao_tipo: "",
      },
      infractionsLevels,
    };
  },
  methods: {
    clear() {
      (this.query.codigo_infracao_tipo = ""),
        (this.query.descricao_infracao_tipo = ""),
        (this.query.nivel_infracao_tipo = ""),
        (this.query.ativo_infracao_tipo = null);
    },
  },
};
</script>
